import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { getComposeEvent, getFullComposeViewState } from 'owa-calendar-compose-store-manager';
import { getComposeCalendarColorScheme } from 'owa-calendar-compose-form-store/lib/selectors/getComposeCalendarColorScheme';
import { updateSidePaneType } from 'owa-calendar-compose-form-actions';
import SidePaneType from 'owa-calendar-sidepane/lib/schema/SidePaneType';
import SidePane from 'owa-calendar-sidepane/lib/component/SidePane';
import loc from 'owa-localize';
import { tracking } from '../../strings.locstring.json';
import { AttendeePanel } from 'owa-vertical-recipient-well';

import styles from './FullComposeTrackingPane.scss';

export interface FullComposeTrackingPaneProps {
    formId: string;
}

const FullComposeTrackingPane: React.FunctionComponent<FullComposeTrackingPaneProps> = props => {
    const { formId } = props;

    const event = getComposeEvent(formId);
    const { currentSidePaneType } = getFullComposeViewState(formId);
    const colorScheme = getComposeCalendarColorScheme(formId);

    const isOpened = currentSidePaneType == SidePaneType.Tracking;

    const onClose = React.useCallback(() => {
        updateSidePaneType(formId, SidePaneType.None);
    }, [formId]);

    return (
        <SidePane title={loc(tracking)} isOpened={isOpened} onClose={onClose}>
            <div className={styles.trackingPanel}>
                <AttendeePanel calendarEvent={event} colorScheme={colorScheme} />
            </div>
        </SidePane>
    );
};

export default observer(FullComposeTrackingPane);
